import { Search } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Card } from "../../components/ui/card.js";
import { parseSmartQuery, type WordFilterDraft } from "./types.js";

export function WordFilters({ onSearch }: { onSearch: (next: WordFilterDraft) => void }) {
  const { t } = useTranslation();
  const [raw, setRaw] = useState("");

  useEffect(() => {
    const id = setTimeout(() => onSearch(parseSmartQuery(raw)), 300);
    return () => clearTimeout(id);
  }, [raw, onSearch]);

  return (
    <Card>
      <div className="flex items-center gap-2 rounded-lg border border-[var(--glass-border)] px-3 focus-within:border-[var(--primary)] focus-within:ring-2 focus-within:ring-[var(--primary)]/25">
        <Search className="h-4 w-4 shrink-0 text-[var(--text-muted)]" aria-hidden />
        <input
          value={raw}
          onChange={(e) => setRaw(e.target.value)}
          placeholder={t("wordFilters.searchPlaceholder")}
          className="w-full bg-transparent py-2 text-sm text-[var(--text-primary)] outline-none placeholder:text-[var(--text-muted)]"
        />
      </div>
    </Card>
  );
}
